import defaultMetrics from '@/organisms/plans/utils/defaultMetrics';
import ActionType from '@/shared/enums/ActionType';
import EntityType from '@/shared/enums/EntityType';
import entityLabel from '@/shared/utils/entityLabel';
import defaultMetricGroup from '@pkg/entities/snapshots/utils/defaultMetricGroup';

export default function updatedBudget({
  actionMap,
  actionType = ActionType.UPDATE_BUDGETS,
  comparisonScenario,
  role,
  scenario,
}) {
  const originalRole = comparisonScenario.relationships
    .get(EntityType.ROLE)
    ?.get(role.uuid);
  const group = role
    ? scenario?.relationships.get(EntityType.GROUP)?.get(role.group_uuid)
    : null;

  const metrics = {
    ...role.__metrics.self.visible,
  };

  const existingAction = actionMap?.get(actionType);

  const action = existingAction ?? {
    entity: EntityType.ROLE,
    impact: defaultMetricGroup(),
    metrics: defaultMetrics({ comparisonScenario }),
    type: actionType,
    [EntityType.ROLE]: new Map(),
    [EntityType.GROUP]: new Set(),
  };

  if (group) {
    action[EntityType.GROUP].add(group.uuid);
  }

  const budgetChange =
    metrics.budget - originalRole.__metrics.self.visible.budget;
  action.metrics[1].budget += budgetChange;

  // Impact changes.
  action.impact.budget += budgetChange;

  // Aggregate the individual role action metrics.
  const actionRole = action[EntityType.ROLE].get(role.uuid) ?? {
    impact: defaultMetricGroup(),
    metrics: defaultMetrics({ comparisonScenario, role }),
  };
  actionRole.metrics[1].budget += budgetChange;
  action[EntityType.ROLE].set(role.uuid, actionRole);

  // Individual role impact changes.
  actionRole.impact.budget = budgetChange;

  const roleCount = action[EntityType.ROLE].size;
  const roleLabel = entityLabel(EntityType.ROLE, roleCount !== 1);

  action.title = `Budget was updated for ${roleCount} ${roleLabel}`;

  return action;
}
